

export const calculateDaysLeft = (startDate, endDate, isActive) => {
    if (!startDate || !endDate) return "Slutdatum saknas";
  
    const today = new Date();
    const end = new Date(endDate);
    const timeDiff = end.getTime() - today.getTime();
    const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
  
    
    if (daysLeft <= 0 && isActive) {
      return "I förlängning";
    }
  
    return daysLeft > 0 ? daysLeft : "Avslutat";
  };



  export const getServiceStatus = (service) => {
    if (service === "Service pågår") {
      return { text: "Service pågår", className: "service-status" };
    }
    return { text: " ", className: "no-service-status" };
  };



  export const getActiveStatus = (status) => {
    if (status === "JA") return { text: "Aktiv", className: "active-status" };
    if (status === "NEJ") return { text: "Avslutad", className: "inactive-status" };
    return { text: "Okänd", className: "unknown-status" };
  };

  

 export const getCommunityStatus = (statusCommunity) => {
    if (statusCommunity === "Informationsmail skickat") return { text: "Informationsmail skickat", className: "community-status1" };
    if (statusCommunity === "Påminnelsemail skickat") return { text: "Påminnelsemail skickat", className: "community-status2" };
    if (statusCommunity === "Inväntar retur") return { text: "Inväntar retur", className: "community-status3" };
    if (statusCommunity === "Mottagen hos Community") return { text: "Mottagen hos Community", className: "community-status5" };
    if (statusCommunity === "Utköp begärt") return { text: "Utköp begärt", className: "community-status6" };
    if (statusCommunity === "Avslutad och utköpt") return { text: "Utköpt", className: "community-status7" };
    if (statusCommunity === "Dialog pågår") return { text: "Dialog pågår", className: "community-status8" };
   return { text: " ", className: "no-service-status"}
  }


  export const sortDevicesByDaysLeft = (devicesArray) => {
    const getSortValue = (device) => {
      const start = device.Avtalsstart;
      const end = device.Avtalsslut;
      const isActive = device.Aktivenhet === "JA";
  
      if (!start || !end) return 90000;
  
      const daysLeft = calculateDaysLeft(start, end, isActive);
  
      if (daysLeft === "I förlängning") return -9999;
      if (daysLeft === "Avslutat") return 99999;
      if (typeof daysLeft === "number") return daysLeft;
  
      return 50000;
    };
  
    return devicesArray.sort((a, b) => getSortValue(a) - getSortValue(b));
  };
  